































































































import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { Node, Edge } from '@/api/graph/';
import { StringMap } from '@/api/i18n/';
import { AnswerMap } from '@/api/AnswerMap';
import { marked } from 'marked';

@Component({ computed: mapState(['stringMap']) })
export default class QuestionCard extends Vue {
    @Prop()
    node!: Node;

    @Prop()
    answers!: AnswerMap;

    @Prop()
    fiSettings!: AnswerMap;

    @Prop({ default: false })
    showBack!: boolean;

    @Prop({ default: false })
    saving!: boolean;

    @Prop({ default: false })
    editMode!: boolean;

    stringMap!: StringMap;

    validEdges: Edge[] = [];

    value: string | string[] | boolean | undefined | null = null;

    disableUnselected: boolean = false;

    mounted() {
      this.value = this.answers[this.node.id];

      this.node.edges.forEach((edge:Edge) => {
        if (edge.evaluateCondition(this.answers)) {
          this.validEdges.push(edge);
        }
      });
    }

    getMarkdownStringAsHTML(stringId: string) {
      return marked(this.stringMap[stringId]);
    }

    onNext() {
      if (this.value !== null) {
        this.$emit('next', this.value);
      }
    }

    onCheckboxClick() {
      const edges:Edge[] = this.node.getEdgesForAnswers(this.value as string[]);

      const excludes: Set<string> = new Set<string>();
      let excludeAll: boolean = false;
      for (let i = 0; i < edges.length; i++) {
        if (edges[i].excludes) {
          if (edges[i].excludes.includes('__OTHER')) {
            if (Array.isArray(edges[i].id)) {
              this.value = edges[i].id;
            } else {
              this.value = [edges[i].id as string];
            }

            excludeAll = true;
            break;
          } else {
            excludes.add(edges[i].id as string);
          }
        }
      }

      this.disableUnselected = excludeAll;

      if (!excludeAll) {
        const newVal: string[] = [];
        (this.value as string[]).forEach((val:string) => {
          if (!excludes.has(val)) {
            newVal.push(val);
          }
        });
        this.value = newVal;
      }
    }
}
